var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blocked-wrap"},[_c('p',{staticClass:"title"},[_vm._v("页面无法访问")]),_c('p',{staticClass:"desc"},[_vm._v("请从活动推广链接进入")])])
}]

export { render, staticRenderFns }